import { ModelsListResponse } from '../api';
import { StepperContextData } from '../contexts/StepperContext';

export type StorageKey =
  | 'stepper_context_data'
  | 'stepper_context_steps'
  | 'candidate_models_data';

export const save = (
  key: StorageKey,
  data: StepperContextData | ModelsListResponse | string[] | undefined | null
) => {
  try {
    sessionStorage.setItem(key, JSON.stringify(data));
  } catch (error) {
    // Silent fail
  }
};

export const load = (key: StorageKey) => {
  try {
    const data = sessionStorage.getItem(key);
    return data ? JSON.parse(data) : null;
  } catch (error) {
    return null;
  }
};

export const clearContextsSessionStorage = () => {
  try {
    sessionStorage.removeItem('stepper_context_data');
    sessionStorage.removeItem('stepper_context_steps');
    sessionStorage.removeItem('candidate_models_data');
  } catch (error) {
    // Silent fail
  }
};
